module.exports = __webpack_public_path__ + "static/media/yellow-balloon.dc80ff86.svg";